export default __webpack_public_path__ + "static/media/Skip.ffb49973.svg";